"use client";

import { motion } from "motion/react";

import { motionTransition } from "../config/animation";
import { fontKufi } from "../config/fonts";

import { Title, Description } from "./section-heading";
import { TextEffect } from "./motion-primitives/text-effect";

interface HeroContentProps {
  title: string;
  description: string;
  headingId?: string;
  onClick?: () => void;
  className?: string;
}

export default function HeroContent({
  title,
  description,
  headingId,
  onClick,
  className,
}: HeroContentProps) {
  return (
    <div className={`flex flex-col justify-center lg:w-1/2 ${className ?? ""}`}>
      <Title
        className={`text-primary-700 leading-relaxed ${fontKufi.variable}`}
        id={headingId}
      >
        <TextEffect as="span" per="word" preset="blur">
          {title}
        </TextEffect>
      </Title>

      <motion.div
        animate={{ opacity: 1, y: 0 }}
        className="pt-6"
        initial={{ opacity: 0, y: 20 }}
        transition={{ ...motionTransition, delay: 0.4 }}
      >
        <Description className="pt-3 leading-7">{description}</Description>
      </motion.div>
    </div>
  );
}
